module.exports = __webpack_public_path__ + "img/PL00158.2f195df1.png";